export default __webpack_public_path__ + "static/media/SIMU02Logo.3163cbb8.svg";